import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import { change_sub_category_status, create_sub_category, delete_sub_category, get_sub_category, get_sub_category_by_category_id, update_sub_category } from '../../utils/api-routes';

function* getSubCategory() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_sub_category}`);
        console.log("Get Sub Category Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_SUB_CATEGORY, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Sub Category Saga Error ::: ", error)
    }
}

function* createSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_sub_category}`, payload?.data);
        console.log("Create Sub Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: "Sub Category Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Create Sub Category",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* updateSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_sub_category}`, payload?.data);
        console.log("Update Sub Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: "Sub Category Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_SUB_CATEGORY, payload: null })
        }

    } catch (error) {
        console.log("Update Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* deleteSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_sub_category}`, payload);
            console.log("Delete Sub Category Saga Response ::: ", data)
            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    text: "Sub Category Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_SUB_CATEGORY, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete SubCategory",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* changeSubCategoryStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_sub_category_status}`, payload);
            console.log("Change Status Sub Category Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_SUB_CATEGORY, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* getSubCategoryByCategoryId(action) {
    const { payload } = action;
    console.log("Payload ::: ", payload)

    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.post, `${api_urls + get_sub_category_by_category_id}`, payload);
        console.log("Get Sub Category By Category ID Saga Response ::: ", data)

        if (data?.status) {
            // yield delay(500);
            yield put({ type: actionTypes.SET_SUB_CATEGORY_BY_CATEGORY_ID, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Sub Category By Category ID Saga Error ::: ", error?.response?.data)
    }
}

export default function* subSubCategorySaga() {
    yield takeLeading(actionTypes?.GET_SUB_CATEGORY, getSubCategory);
    yield takeLeading(actionTypes?.CREATE_SUB_CATEGORY, createSubCategory);
    yield takeLeading(actionTypes?.UPDATE_SUB_CATEGORY, updateSubCategory);
    yield takeLeading(actionTypes?.DELETE_SUB_CATEGORY, deleteSubCategory);
    yield takeLeading(actionTypes?.CHANGE_SUB_CATEGORY_STATUS, changeSubCategoryStatus);
    yield takeLeading(actionTypes?.GET_SUB_CATEGORY_BY_CATEGORY_ID, getSubCategoryByCategoryId);
};
